"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nouns = exports.adjectives = void 0;
const adjectives_1 = require("./adjectives");
exports.adjectives = adjectives_1.default;
const nouns_1 = require("./nouns");
exports.nouns = nouns_1.default;
